<span class="stepsIndicator__dot">{{this}}</span>


